export const clientRouterPaths = {
  home: '/',
  auth: '/auth',
  authFinish: '/auth-finish',
};
